import React from 'react';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const DILIGENTSIA = 'https://diligentsia.co.uk';

const PECtaSection = () => (
    <section className="lp-pe-cta">
        <div className="lp-pe-cta-card" data-lp-reveal>

            <div className="lp-pe-cta-col">
                <div className="lp-pe-cta-eyebrow">Talk to us</div>
                <h3>See Diligentsia in action.</h3>
                <p>30 minutes with Mark Bernstein. Free, no commitment.</p>
                <a className="lp-pe-cta-btn" href={KOALENDAR} target="_blank" rel="noopener noreferrer">
                    <span className="av"><img src={require('../../../../images/landing-pages/PE/book-a-call-mark.png')} alt="Mark Bernstein" /></span>
                    Book a call
                </a>
            </div>

            <div className="lp-pe-cta-divider" aria-hidden="true" />

            <div className="lp-pe-cta-col">
                <div className="lp-pe-cta-eyebrow">Already in our database?</div>
                <h3>Check your fund's details.</h3>
                <p>We may have already added your fund from public information. Check — and update — any time.</p>
                <a className="lp-pe-cta-btn lp-pe-cta-btn--pink" href={DILIGENTSIA} target="_blank" rel="noopener noreferrer">Investor Database Check</a>
                <p className="lp-pe-cta-fine">Free to check. No commitment.</p>
            </div>

        </div>

        <div className="lp-pe-cta-foot">
            <p>mark.bernstein@diligentsia.co.uk · diligentsia.co.uk</p>
        </div>
    </section>
);

export default PECtaSection;
